import * as React from "react"
import {
  Text,
  Box,
  BoxProps,
  useColorMode,
} from "@chakra-ui/react"

interface LogoProps extends BoxProps {
  color?: string;
}

// Main Logo component
export const Logo = React.forwardRef<HTMLDivElement, LogoProps>(({ color, ...props }, ref) => {
  const { colorMode } = useColorMode();

  // Use provided color, or switch based on color mode
  const textColor = color || (colorMode === 'light' ? "#2D2D2D" : "#FFFFFF");

  return (
    <Box ref={ref} {...props}>
      <Text
        fontSize={{ base: "xl", md: "3xl" }}
        fontFamily="'Mokoto Demo', 'Arial Black', sans-serif"
        fontWeight="bold"
        letterSpacing="0.15em"
        textTransform="uppercase"
        color={textColor}
        fontStyle="normal"
      >
        VANGUARD IQ
      </Text>
    </Box>
  )
})

Logo.displayName = 'Logo'

export default Logo;
